import MerchLandingPage from './MerchLandingPage';

export default MerchLandingPage;
